/** Normalise organisation tokens only in trusted branding labels, never user content. */
export function normaliseBrandTitle(value: unknown, fallback = 'Scholarvest'): string {
  if (typeof value !== 'string' || !value.trim()) return fallback;
  // Protect addresses, URLs and operational tokens, even inside a custom title.
  return value.replace(/(?:https?:\/\/|www\.|\/|\.\.?\/)\S+|[\w.+-]+@[\w.-]+|[\w.-]+\.[a-z]{2,}(?:\/\S*)?|Wellspring (?:School Support(?: Services)?|Student Support Services)|Worldwide Student Support Services|Scholar Vest|[\w-]+/gi, (token) => {
    if (/^(?:scholarvest|scholar vest|wsss|Wellspring (?:School Support(?: Services)?|Student Support Services)|Worldwide Student Support Services)$/i.test(token)) return 'Scholarvest';
    return token;
  }).replace(/^Scholarvest\s*-\s*Scholarvest$/i, 'Scholarvest');
}

export function normaliseBrandSettings<T extends Record<string, unknown>>(settings: T): T {
  const result = { ...settings };
  for (const key of ['siteName', 'adminPortalTitle', 'agentPortalTitle', 'studentPortalTitle']) {
    if (key in result) (result as Record<string, unknown>)[key] = normaliseBrandTitle(result[key]);
  }
  return result;
}
